<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20" 
  >
    <path d="M3.99988 4.5C3.99988 3.11929 5.11917 2 6.49988 2H13.4999C14.8806 2 15.9999 3.11929 15.9999 4.5V17.5C15.9999 17.6881 15.8944 17.8602 15.7268 17.9456C15.5592 18.0309 15.3579 18.015 15.2058 17.9044L9.99988 14.1182L4.79396 17.9044C4.64187 18.015 4.44057 18.0309 4.27299 17.9456C4.1054 17.8602 3.99988 17.6881 3.99988 17.5V4.5ZM6.49988 3C5.67145 3 4.99988 3.67157 4.99988 4.5V16.5181L9.7058 13.0956C9.88112 12.9681 10.1186 12.9681 10.294 13.0956L14.9999 16.5181V4.5C14.9999 3.67157 14.3283 3 13.4999 3H6.49988Z" fill="#0F0017"/>
  </svg>
</template>
